module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<form>\n\n\n    <div class="tab-contents js-tabs-container">\n\n        <!-- Basic Section -->\n        <div class="m-modal-section m-tab" id="tab-basic">\n\n            <div class="m-modal-column">\n\n                <div class="form-group">\n                    <label for="name">Name</label>\n                    <input type="input" class="form-control" name="name" placeholder="" value="'+
((__t=( obj.name ))==null?'':__t)+
'">\n                </div>\n                <div class="form-group">\n                    <label for="name">Email</label>\n                    <input type="input" class="form-control" name="email" placeholder="" value="'+
((__t=( obj.email ))==null?'':__t)+
'">\n                </div>\n                  <div class="form-group">\n                      <label for="name">Password</label>\n                      ';
 if (!obj._id) { 
__p+='\n                      <input type="password" class="form-control" name="password" placeholder="*******" value="'+
((__t=( obj.password ))==null?'':__t)+
'">\n                      ';
 } else { 
__p+='\n                      <div>\n                        <a class="m-btn m-btn--secondary js-send-new-password" role="button">send new password</a>\n                      </div>\n                      ';
 } 
__p+='\n                  </div>\n\n\n\n\n\n            </div>\n\n            <div class="m-modal-column">\n                <div class="form-group">\n                    <label for="name">Role</label>\n\n                    <select class="form-control js-selected-role-type" name="role">\n                        <option value="">Choose...</option>\n\n                        ';
 _.each(getUserRoles(), function(value, key){ 
__p+='\n                        ';
 if (obj._id) { 
__p+='\n                        <option value="'+
((__t=( key ))==null?'':__t)+
'" '+
((__t=( key === role ? 'selected' : void 0  ))==null?'':__t)+
'  >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                        ';
 } else { 
__p+='\n                        <option value="'+
((__t=( key ))==null?'':__t)+
'" >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                        ';
 } 
__p+='\n\n                        ';
 }); 
__p+='\n                    </select>\n                </div>\n\n                <div class="form-group">\n                    <label for="name">Mobile phone</label>\n                    <input type="input" class="form-control" name="phone" placeholder="" value="'+
((__t=( obj.phone ))==null?'':__t)+
'">\n                </div>\n            </div>\n        </div>\n\n        <!-- Notifications Section -->\n        <div class="m-modal-section m-tab" id="tab-notifications">\n\n            <div class="m-modal-subsection" >\n                <div class="m-modal-subsection__title"></div>\n                <div class="m-modal-row">\n                    <div class="form-group">\n                        <input type="checkbox" name="notifications[operatingWindowException]"  ';
 if (_.get(obj, 'notifications.operatingWindowException')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                        <label for="" class="">Notify when operating window exceptions occur</label>\n                    </div>\n                    <div class="form-group">\n                        <input type="checkbox" name="notifications[deviceError]"  ';
 if (_.get(obj, 'notifications.deviceError')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                        <label for="" class="">Notify when a device is in error mode</label>\n                    </div>\n                </div>\n            </div>\n\n            <div class="m-modal-subsection" >\n                <div class="m-modal-subsection__title">Notification channels</div>\n                <div class="m-modal-row">\n                    <div class="form-group">\n                        <div>\n                            <input type="checkbox" name="notifications[channels][email]"  ';
 if (_.get(obj, 'notifications.channels.email')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                            <label for="" class="">Use email</label>\n                        </div>\n                        <div>\n                            <input type="checkbox" name="notifications[channels][sms]"  ';
 if (_.get(obj, 'notifications.channels.sms')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                            <label for="" class="">Use sms</label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/client-users/edit_new/templates/body.html
// module id = 421
// module chunks = 0